// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/resources/styles/BigCalendar.css
// module id = 396
// module chunks = 0